import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit';
import * as style from './style.css';

interface IInfrastructureItemTooltipProps {
  title: string;
}
export const InfrastructureItemTooltip = ({ title }: IInfrastructureItemTooltipProps) => {
  return (
    <div className={style['tooltip']}>
      <UIHeading3>{title}</UIHeading3>
    </div>
  );
};
